import Utility from '@/utils/Utility'

export default {
  name: 'TypeSoundBroadcast',
  props: {
    model: {
      type: Object,
      required: true,
    }
  },
  mounted () {

  },
  computed: {
    showSoundFile() {
      return this.model.soundFile
    },
    soundFile() {
      return this.model.soundFile
    }
  },
}
